module.exports = __webpack_public_path__ + "img/HR08106331075.0189ca9d.svg";